import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { LadyProfileQueryOptions, LadyProfileDtoRaw } from "../models";
import { mapData } from "./helpers";

export abstract class LadyProfileApi {
  static getInfo = async (params: LadyProfileQueryOptions) => {
    if (!params.objectId) return null;

    const objectId = `${params.objectId}`.match(/id(.*?)$/)?.[1];
    const response = GbApiRequestService.get("userApi", {
      params: {
        id: objectId,
        requestType: "lady",
      },
    });

    const validatedData = await withSchemaValidation(
      response,
      LadyProfileDtoRaw,
    );

    return mapData(validatedData);
  };
}
